module.exports = __webpack_public_path__ + "static/media/picture-(108).14668e96.JPG";